import React, { useEffect, useState } from 'react';
import { Col, Row, Card } from 'react-bootstrap';
import { getAllHVAAgents, HVAAgent } from 'services/hvaagent.service';
import { hvaImagesandVoices } from 'pages/hva/hvaImagesandVoices';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faPause } from '@fortawesome/free-solid-svg-icons';
import HVAConversationModal from 'components/hva/HVAConversationModal';
import spanish from 'assets/img/flags/spain.png'; // Importar banderas
import english from 'assets/img/flags/england.png';
import greek from 'assets/img/flags/greece.png';
import mexican from 'assets/img/flags/mexico.png';
import german from 'assets/img/flags/germany.png';
import brasilian from 'assets/img/flags/brazil.png';
import italian from 'assets/img/flags/italy.png';
import chilean from 'assets/img/flags/chile.png';
import turkish from 'assets/img/flags/turkey.png';
import colombian from 'assets/img/flags/colombia.png';
import peruvian from 'assets/img/flags/peru.png';
import argentine from 'assets/img/flags/argentina.png';
type Language =
  | 'spanish'
  | 'english'
  | 'greek'
  | 'mexican'
  | 'german'
  | 'brasilian'
  | 'italian'
  | 'chilean'
  | 'turkish'
  | 'colombian'
  | 'peruvian'
  | 'argentine';

const YourHVAs = () => {
  const [agents, setAgents] = useState<HVAAgent[]>([]);
  const [currentAudio, setCurrentAudio] = useState<HTMLAudioElement | null>(
    null
  );
  const [playingAgent, setPlayingAgent] = useState<string | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState<HVAAgent | null>(null);

  useEffect(() => {
    const fetchAgents = async () => {
      const agentsData = await getAllHVAAgents();
      setAgents(agentsData);
    };
    fetchAgents();
  }, []);

  const getImagePath = (bxpname: string): string | undefined => {
    return hvaImagesandVoices[bxpname]?.image;
  };

  const getAudioPath = (bxpname: string): string | undefined => {
    return hvaImagesandVoices[bxpname]?.audio;
  };

  const languageToFlag: Record<Language, string> = {
    spanish: spanish,
    english: english,
    greek: greek,
    mexican: mexican,
    german: german,
    brasilian: brasilian,
    italian: italian,
    chilean: chilean,
    turkish: turkish,
    colombian: colombian,
    peruvian: peruvian,
    argentine: argentine
  };

  const handleAudioPlayPause = (bxpname: string) => {
    const audioPath = getAudioPath(bxpname);
    if (!audioPath) return;

    if (currentAudio && playingAgent === bxpname) {
      if (currentAudio.paused) {
        currentAudio.play();
      } else {
        currentAudio.pause();
        setPlayingAgent(null);
      }
    } else {
      if (currentAudio) {
        currentAudio.pause();
        setPlayingAgent(null);
      }

      const newAudio = new Audio(audioPath);
      setCurrentAudio(newAudio);
      setPlayingAgent(bxpname);
      newAudio.play();

      newAudio.onended = () => {
        setPlayingAgent(null);
      };
    }
  };

  const handleConversationError = (error: Error) => {
    // Handle conversation errors appropriately
    console.error('Conversation error:', error);
    // You might want to show a toast or notification here
  };

  const handleCloseChat = () => {
    setSelectedAgent(null);
    setShowModal(false);
  };

  return (
    <>
      <Row className="gy-3 mb-6 justify-content-between">
        <Col>
          <h2 className="mb-2 text-body-emphasis">Some HVAs</h2>
          <h5 className="text-body-tertiary fw-semibold">
            Humanized Virtual Agents (HVAs) showroom.
          </h5>
        </Col>
      </Row>
      <Row className="p-0">
        {agents.map(agent => (
          <Col key={agent.id} sm={12} md={12} xl={6} xxl={4} className="pb-3">
            <Card className="h-100 position-relative">
              <Card.Body className="p-0">
                <img
                  src={languageToFlag[agent.language as Language] || spanish}
                  alt="Language"
                  className="position-absolute"
                  style={{ top: '0px', right: '0px' }}
                />
                <Row>
                  <Col
                    className="d-flex align-items-center justify-content-center p-4 pe-0"
                    style={{ width: '140px', minWidth: '140px' }}
                  >
                    {getImagePath(agent.bxpname) ? (
                      <img
                        src={getImagePath(agent.bxpname)}
                        alt={`${agent.name}`}
                        className="img-fluid"
                        style={{ width: '140px', height: 'auto' }}
                      />
                    ) : (
                      <p>Image not found</p>
                    )}
                  </Col>
                  <Col className="d-flex flex-column align-items-center">
                    <div>
                      <h4 className="text-body-emphasis pt-6 pb-1 me-7 text-center">
                        {agent.name}
                      </h4>
                      <div className="text-primary me-8 text-center">
                        <FontAwesomeIcon
                          icon={
                            playingAgent === agent.bxpname ? faPause : faPlay
                          }
                          onClick={() => handleAudioPlayPause(agent.bxpname)}
                          style={{ cursor: 'pointer', marginLeft: '10px' }}
                        />
                      </div>
                      <div className="h-100 fs-9 pt-2 me-5 lh-sm">
                        {agent.description}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {selectedAgent && (
        <HVAConversationModal
          show={showModal}
          onHide={handleCloseChat}
          agentCode={selectedAgent.agentcode}
          agentName={selectedAgent.name}
          agentImage={getImagePath(selectedAgent.bxpname)}
          onError={handleConversationError}
        />
      )}
    </>
  );
};

export default YourHVAs;
